// Delete my account and data (Q21): confirmed by typing DELETE (the button stays off until it's typed),
// with a backup download offered in the same dialog (25 Oct 2026).
import { sb } from '../lib/supabase';

export function deleteAccountFlow(opts: { backup?: () => void } = {}): Promise<void> {
  const d = document.getElementById('dlg') as HTMLDialogElement;
  d.innerHTML = `<form method="dialog" novalidate><h2>Delete your account and data?</h2>
    <p class="dim" style="margin-top:8px">Your ledger, value history, uploaded files and sign-in are deleted for good, on every device. Download a backup first if you might want them later. Type DELETE to confirm.</p>
    <div class="fgrid"><label class="full">Type DELETE<input id="delConfirm" autocomplete="off" spellcheck="false"></label></div>
    <p class="err" role="alert"></p>
    <div class="dlg-actions">${opts.backup ? '<button class="btn" type="button" id="delBackup">Download a backup first</button>' : ''}<button class="btn" value="cancel">Cancel</button><button class="btn danger" type="button" id="delGo" disabled>Delete everything</button></div></form>`;
  const word = d.querySelector('#delConfirm') as HTMLInputElement, go = d.querySelector('#delGo') as HTMLButtonElement;
  word.addEventListener('input', () => { go.disabled = word.value.trim() !== 'DELETE'; });
  const bk = d.querySelector('#delBackup') as HTMLButtonElement | null;
  if (bk && opts.backup) bk.onclick = opts.backup;
  d.showModal();
  return new Promise((resolve) => {
    d.onclose = () => resolve();
    (d.querySelector('#delGo') as HTMLButtonElement).onclick = async (e) => {
      const b = e.currentTarget as HTMLButtonElement, err = d.querySelector('.err') as HTMLElement;
      if ((d.querySelector('#delConfirm') as HTMLInputElement).value.trim() !== 'DELETE') { err.textContent = 'Type DELETE to confirm.'; return; }
      b.disabled = true; b.textContent = 'Deleting…';
      const { error } = await sb().rpc('delete_my_account');
      if (error) { err.textContent = 'Couldn’t delete your account: ' + error.message; b.disabled = false; b.textContent = 'Delete everything'; return; }
      try { for (const k of Object.keys(localStorage)) if (k.startsWith('pf-ledger')) localStorage.removeItem(k); } catch { /* storage may be unavailable */ }
      await sb().auth.signOut();
      d.onclose = null; d.close(); resolve();
    };
  });
}
